
import {Vue, Component} from 'vue-property-decorator';
import ModalOkrtuForm from './ModalPlanningNew.vue'
import VueElementLoading from "vue-element-loading";
import {OktruProductSelection, SaveProductSelectionResult} from './services/oktru-save.service';

@Component({
    components: {
        'loading': VueElementLoading,
        'modal-oktru-form': ModalOkrtuForm
    }
})

export default class extends Vue {
    product: OktruProductSelection | null = null;
    isSaving = false;
    saveResult: SaveProductSelectionResult | null = null;

    productSelected(product: OktruProductSelection) {
        this.product = product;
        this.$bvModal.hide("modal-1");
        // сохранение в БД выполняет сама модалка, здесь только показываем результат
        this.isSaving = true;
        this.saveResult = null;
    }

    /** Результат сохранения в БД, пришедший из модалки */
    oktruSaved(result: SaveProductSelectionResult) {
        this.saveResult = result;
        this.isSaving = false;
    }

    /** Сохранение в БД завершилось ошибкой (сообщение уже показала модалка) */
    oktruSaveError() {
        this.isSaving = false;
    }

    /** Параметры режима "сразу на карточке": null - обычный каталог */
    directProductId: number | null = null;
    directOktruCode: string | null = null;
    widgetKey = 0;
    closedMessage: string | null = null;

    productIdInput = "";
    oktruCodeInput = "";

    openNKT() {
        this.directProductId = null;
        this.directOktruCode = null;
        this.openWidget();
    }

    openByProductId() {
        const id = parseInt(this.productIdInput, 10);
        if (Number.isNaN(id)) {
            return;
        }
        this.directProductId = id;
        this.directOktruCode = this.oktruCodeInput.trim() || null;
        this.openWidget();
    }

    openWidget() {
        this.product = null;
        this.saveResult = null;
        this.closedMessage = null;
        this.widgetKey += 1;
        this.$bvModal.show("modal-1");
    }

    /** Виджет завершил работу без выбора - закрываем окно, текст сообщения наш */
    widgetClosed(payload: { reason: string }) {
        this.$bvModal.hide("modal-1");
        this.closedMessage = this.$t(`modules.oktru_example.closed_${payload.reason}`).toString();
    }

}
